import { render, staticRenderFns } from "./goods-in.vue?vue&type=template&id=5bfd8d08"
import script from "./goods-in.vue?vue&type=script&lang=js"
export * from "./goods-in.vue?vue&type=script&lang=js"
import style0 from "./goods-in.vue?vue&type=style&index=0&id=5bfd8d08&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports